export default __webpack_public_path__ + "static/media/1.e6a60ecd.png";